module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.8 153"><path class="st3" fill="#e30613" d="M0 0h264.8v153H0z"/><ellipse transform="rotate(-60.482 96.202 75.768)" class="st0" cx="96.2" cy="75.8" rx="47" ry="47" fill="#fff"/><circle class="st3" cx="106.6" cy="76.2" r="41.1" fill="#e30613"/><path class="st0" fill="#fff" d="M140.5 64.8l16.8-2.2-8.4 14.7 7.3 15.3-16.6-3.5-12.3 11.6-1.8-16.8-14.9-8.1 15.5-6.9 3.1-16.6z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg10.svg
// module id = 519
// module chunks = 1